import React from 'react';
import PropTypes from 'prop-types';

import RealityCheckButton from 'components/ClientProfile/ResponsibleGaming/RealityCheck/RealityCheckButton';

const RealityCheckVariant = [
  {
    text: '1 min',
    value: 'MINUTE_1',
  },
  {
    text: '5 min',
    value: 'MINUTE_5',
  },
  {
    text: '10 min',
    value: 'MINUTE_10',
  },
  {
    text: '20 min',
    value: 'MINUTE_20',
  },
  {
    text: '30 min',
    value: 'MINUTE_30',
  },
  {
    text: '1 hour',
    value: 'HOUR_1',
  },
  {
    text: '2 hour',
    value: 'HOUR_2',
  },
  {
    text: '4 hour',
    value: 'HOUR_4',
  },
  {
    text: '6 hour',
    value: 'HOUR_6',
  },
  {
    text: 'Do Not Remind',
    value: 'NEVER',
  },
];

const RealityCheckChips = ({ selectedPeriod, setSelectedPeriod }) => (
  <div className="chips-list chips-list-wrap">
    {RealityCheckVariant.map(({ text, value }) => (
      <RealityCheckButton
        key={value}
        period={value}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        text={text}
      />
    ))}
  </div>
);

RealityCheckChips.propTypes = {
  selectedPeriod: PropTypes.string.isRequired,
  setSelectedPeriod: PropTypes.func.isRequired,
};

export default RealityCheckChips;
